
import { Button, useTheme } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import { iconos } from '../../../data';





export const BotonesAndCargando = ({ cargando, titulo, titulo2, icon1, icon2, handleSubmit, esSubmit }) => {

    const theme = useTheme();
    // const colorfd = `linear-gradient(135deg, ${theme.palette.secondary.light}, ${theme.palette.secondary.dark})`;
    const colorfd = `linear-gradient(135deg, ${theme.palette.secondary.light} 0%, ${theme.palette.secondary.dark} 80%)`;





    if (cargando) {
        return (
        <LoadingButton
            fullWidth
            loading
            loadingPosition="start"
            startIcon={iconos[icon2]}
            variant="contained"
        >
            { titulo2 }
        </LoadingButton>
        );
    }

    return (
        <Button
            fullWidth
            variant="contained"
            startIcon={iconos[icon1]}
            sx={{ background: colorfd }}
            {...(esSubmit ? { type: 'submit' } : { onClick: handleSubmit })}
        >
            { titulo }
        </Button>
    );
}
